import { routes, useMakeUrl } from "../lib/urls";

export type ChatReference = {
  href: string;
  type: keyof typeof routes.modal.cases;
  id: string | undefined;
};

export function useChatReference() {
  const makeUrl = useMakeUrl();
  return (href: string): ChatReference | null => {
    let url: URL;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return null;
    }
    if (url.origin !== window.location.origin || url.pathname !== "/")
      return null;

    const type = url.searchParams.get("modal");
    if (!type || !Object.hasOwn(routes.modal.cases, type)) return null;
    const modalType = type as ChatReference["type"];

    const params: Record<string, string> = {};
    for (const [key, value] of url.searchParams) {
      const match = /^modal\[([^\]]+)\]$/.exec(key);
      if (match) params[match[1]!] = value;
      else if (key !== "modal") return null;
    }
    return {
      href: makeUrl(routes.modal[modalType], params),
      type: modalType,
      id: params.id,
    };
  };
}
